<template>
  <div class="body-container order-page">
    <div class="head-box">
      <van-tabs v-model="activeIndex" @change='tabClick' class="list-tabs small">
        <van-tab title="长险续费" :name="2"></van-tab>
        <van-tab title="短险续保" :name="1"></van-tab>
      </van-tabs>
    </div>
    <ul class="child-type" v-if="(listLoading||list.length||typeId)&&activeIndex==2">
      <li v-for="(item,i) in typeList2" :key="i" :class="{'active':typeId==item.id}" @click="clickTypeLevel2(item.id)">{{item.name}}</li>
    </ul>
    <ul class="child-type" v-if="(listLoading||list.length||typeId)&&activeIndex==1">
      <li v-for="(item,i) in typeList3" :key="i" :class="{'active':typeId==item.id}" @click="clickTypeLevel2(item.id)">{{item.name}}</li>
    </ul>
    <orderList ref="list" :pageFlag="pageFlag" :policyType="activeIndex" :isOrder="activeIndex==-1" @setListParams="setListParams" @listCallback="listCallback"></orderList>
  </div>
</template>

<script>
import orderList from "@/components/order/list";
import {pageTools,common} from "@/api/mixins";
export default {
  mixins:[pageTools,common],
  components:{orderList},
  data() {
    return {
      pageFlag:'xfFlag',
      listLoading:false,
      typeId:"2",
      typeList2:[
        {name:"待续费",id:"2"},
        {name:"已续费",id:"5"},
        {name:"续费失败",id:"6"},
      ],
      typeList3:[
        {name:"待续保",id:"2"},
        {name:"已续保",id:"5"},
        {name:"续保失败",id:"6"},
      ],
      showSelectPanel:false,//账户类型弹窗
      typeName:"全部账户",
      name: "",//投/被人姓名
      startTime:"",
      endTime:"",
      incomes:"",//服务费
      totalFee:"",//保费
      ordersNum:"",//订单数
      activeIndex: 2,
      list:[],
    };
  },
  mounted() {
    if(!this.checkLogin()){
      return;
    }
    sessionStorage.policyType = 1 // 默认短险续保
    // if(sessionStorage.bdgjRenewTab) {
    //   this.activeIndex = sessionStorage.bdgjRenewTab*1;
    // }
    // if(sessionStorage.bdgjRenewTab2) {
    //   this.typeId = sessionStorage.bdgjRenewTab2*1;
    // }
    // 查询订单列表
    this.$weixin.hideMenu();
    // 初始化列表
    this.$refs.list.init();
  },
  methods: {
    listCallback(res){
      this.listLoading = false;
      this.list = res.data;
      //list页面字段显示需要更改样式，所以进行字符串截取
      this.list.map(item=>{
        if(item.needRenewalDesc){
          let strArr = this.handleParams(item.needRenewalDesc)
          let str = strArr.pop()
          let index = item.needRenewalDesc.indexOf(str)
          item.needRenewalTilte = item.needRenewalDesc.substring(0,index)
          let num = item.needRenewalDesc.substring(index)
          item.needRenewalNum = num.substring(0,num.length-1)
          item.needRenewalDay = item.needRenewalDesc.substr(-1,1)
        }
      })
    },
    // 获取字符串中所有数字
    handleParams(str){
      let ary = [];
      let tem = "";
      for(let i=0;i<str.length;i++){
          if(str.charAt(i) >= "0" && str.charAt(i) <= "9"){
              tem += str.charAt(i)
          }else{
              if(tem){
                  ary.push(tem);
                  tem = "";
              }
          }
      }
      if(tem){
          ary.push(tem);
          tem = "";
      }
      return ary;
    },
    //设置产品参数
    setListParams(params){
      this.listLoading = true;
      this.$refs.list.listUrl = `/api/queryRenewalPolicys`;
      params.policyType = this.activeIndex;
      params.renewalStatus = Number(this.typeId);
      return params
    },
    // 列表跳转
    goPage(url, params, e) {
      if(e.target.className.indexOf("copy") != -1){
        return;
      }
      this.$router.push({
        path: url,
        query: params
      });
    },
    tabClick(){
      sessionStorage.policyType = this.activeIndex;
      this.list = [];
      this.$refs.list.searchAjax();
    },
    clickTypeLevel2(id){
      this.listLoading = true;
      this.typeId = id;
      // sessionStorage.bdgjRenewTab2 = id;
      this.$refs.list.searchAjax();
    }
  },

};
</script>

<style lang="scss" scoped>
@import "./list";
.list-tabs {
  /deep/ .van-tab {
    width: 50%;
  }
}
</style>
